import omit from 'lodash-es/omit';
import { buildTestsQueryVariables } from 'src/apps/dashboard/services/queries/Tests/helpers/buildVariables';
import { transformTestsResults } from 'src/apps/dashboard/services/queries/Tests/helpers/transformResults';
import {
	DashboardWebSdkRecentTestsQuery,
	DashboardWebSdkTestsQuery
} from 'src/apps/dashboard/services/queries/Tests/Tests.generated';
import {
	IGetWebSdkTestsParams,
	TWebSdkTestsResult
} from 'src/apps/dashboard/types/WebSdkDashboardServiceTypes';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import { DashboardWebSdkRecentTests, DashboardWebSdkTests } from '../queries/Tests/Tests.gql';

export const getWebSdkTests = async (
	params: IGetWebSdkTestsParams
): Promise<TWebSdkTestsResult> => {
	try {
		const { isRecentTests } = params;
		const queryParams = omit(params, ['isRecentTests']);

		const variables = buildTestsQueryVariables(queryParams);

		if (isRecentTests) {
			const query = DashboardWebSdkRecentTests;
			const result = await gqlClient.request<DashboardWebSdkRecentTestsQuery>(query, variables);

			return transformTestsResults(result);
		}

		const query = DashboardWebSdkTests;
		const result = await gqlClient.request<DashboardWebSdkTestsQuery>(query, variables);

		return transformTestsResults(result);
	} catch (e) {
		Logger.error('WebSdkTestsService.ts -> getWebSdkTests failed with an error:', e);
		throw e;
	}
};
